import styled from 'styled-components';

const FormHeader = styled.div`
  border-bottom: 1px solid #c5d0db;
  padding: 24px 32px;
  margin-top: -24px;
  margin-right: -32px;
  margin-left: -32px;
  border-radius: 6px 6px 0 0;
`;

export default FormHeader;
